import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const buildVersion = process.env.REACT_APP_BUILD_VERSION || Date.now();

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'nl',
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json?v=${buildVersion}`,
        },
        ns: ['translation'],
        defaultNS: 'translation',
        interpolation: {
            escapeValue: false
        },
    })
    .catch(() => {
    });

export default i18n;
